/*
 * Copyright (c) 2020 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The Table component
 *
 * @author Thais Watanabe
 */
const Table = (props) => {
  return (
    <div className="flex flex-col">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table
              id={props.id}
              className="min-w-full divide-y divide-gray-200"
            >
              {props.children}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * TableHead
 * @param {*} props
 */
const TableHead = (props) => {
  return (
    <thead className="bg-gray-50">
      {props.children}
    </thead>
  );
};

/**
 * ColHeader
 * @param {*} props
 */
const ColHeader = (props) => {
  return (
    <th
      colSpan={props.colSpan}
      rowSpan={props.rowSpan}
      scope="col"
      className={`${props.className} p-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider print:p-2`}
    >
      {props.children}
    </th>
  );
};

/**
 * Col
 * @param {*} props
 */
const Col = (props) => {
  return (
    <td
      colSpan={props.colSpan}
      rowSpan={props.rowSpan}
      className={`${props.className} p-3 text-sm text-gray-500 print:p-1 print:text-xs`}
    >
      {props.children}
    </td>
  );
};

/**
 * TableBody
 * @param {*} props
 */
const TableBody = (props) => {
  return (
    <tbody className="bg-white divide-y divide-gray-200">
      {props.children}
    </tbody>
  );
};

export { Table, TableHead, ColHeader, TableBody, Col };
